'use strict'

Object.defineProperty(exports, '__esModule', {
  value: true
})
exports.default = {
  dataIterator: {
    rowsPerPageText: 'Elementi per pagina:',
    rowsPerPageAll: 'Tutti',
    pageText: '{0}-{1} di {2}',
    noResultsText: 'Nessun risultato trovato',
    nextPage: 'Pagina seguente',
    prevPage: 'Pagina precedente'
  },
  dataTable: {
    rowsPerPageText: 'Righe per pagina:'
  },
  noDataText: 'Nessun elemento disponibile',
  lobis: {
    login: 'Login',
    request_code: 'Richiesta codice',
    go_back: 'Indietro',
    code_requeired: 'Inserisci un codice',
    phonenumber_requeired: 'Inserisci un numero telefonico',
    noResultsForPosition: 'Nessuna inserzione per questa posizione',
    billingAmount: 'Somma da fatturare',
    editTimeEntry: 'Modifica ore lavorative',
    addTimeEntry: 'Inserire ore lavorative',
    selectCustomer: 'Seleziona cliente',
    queryCustomer: 'Ricerca cliente',
    selectProject: 'Seleziona progetto',
    queryProject: 'Ricerca progetto',
    cancel: 'Cancella',
    ok: 'Ok',
    squaremeters: 'metri quadri',
    orders: 'Ordini',
    note: 'Nota',
    edit: 'modifica',
    add: 'aggiungi',
    sending: 'invia',
    addedSuccessfully: 'inserito con successo',
    timeEntries: 'inserimento ore',
    customer: 'cliente',
    contactPerson: 'Persona di riferimento',
    phoneNumber: 'numero telefonico',
    route: 'arrivo',
    address: 'indirizzo',
    startNavigation: 'partenza navigazione',
    myEntriesForPosition: 'inserzioni mie per questa posizione',
    insertCode: 'Codice..',
    language: 'Lingua',
    history: 'History',
    manualEntry: 'Inserimento manuale',
    workreport: 'Regie',
    date: 'Data',
    begin: 'Inizio',
    end: 'Fine',
    duration: 'Durata',
    qtyDone: '{0} fatto',
    qty: 'qunatitá',
    settings: 'Impostazioni',
    italian: 'Italiano',
    german: 'Deutsch',
    planned_hours_cold: 'Ore pianificate pavimenti freddi',
    planned_hours_warm: 'Ore pianificate pavimenti caldi',
    logout: 'Logout',
    logoutconfirmation: 'Sei sicuro?',
    planner: 'calendario',
    billinglist: 'rimisurazione'
  }
}
// # sourceMappingURL=it.js.map



// WEBPACK FOOTER //
// ./src/lang/it.js